<template>
    <div v-loading="loading" style="margin-bottom: 20px">
        <div class="layout-history">
            <div>
                <div class="layout-between">
                    <span>Thay đổi cũ</span>
                    <span>có {{ dataHistory.length }} lần thay đổi</span>
                </div>
                <div class="sidebar-left">
                    <div v-if="dataHistory && dataHistory.length > 0">
                        <div
                            v-for="item in dataHistory" :class="historySelected.id === item.id ? 'highlight-version' : 'not-highlight__version'"
                            :key="item.id" @click="handleSelectHistory(item)"
                            style="padding: 8px; display: flex; flex-direction: column; cursor: pointer;"
                        >
                            <span>{{ getDate(item.updated_at) }}</span>
                            <span style="font-weight: 500">Thay đổi thông tin KRAs</span>
                        </div>
                    </div>
                    <span v-else class="d-flex justify-content-center w-100">Chưa có thay đổi nào</span>
                </div>
            </div>
            <div>
                <div class="layout-between">
                    <span v-if="dataHistory && dataHistory.length > 0">{{ getDate(dataHistory[0].updated_at) }}</span>
                </div>
                <KraChangeHistory :kra-change-history="historySelected"/>
            </div>
        </div>
    </div>
</template>

<script>
import {TEAM_LEAD_KRA_HISTORY} from "@/core/services/store/kpi/kpi.module";
import KraChangeHistory from "./KraChangeHistory.vue";
import moment from "moment-timezone";

export default {
    name: 'DialogHistory',
    components: {KraChangeHistory},
    props: {
        userInfo: {
            type: Object,
            required: true,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            dataHistory: [],
            historySelected: {},
        }
    },
    methods: {
        moment,
        getHistory() {
            this.loading = true
            const payload = {
                user_id: this.userInfo.user_id,
                year: this.userInfo.year,
                month: this.userInfo.month,
            }
            this.$store.dispatch(TEAM_LEAD_KRA_HISTORY, payload).then(res => {
                if (!res.error) {
                    this.dataHistory = res.data ?? []
                    this.historySelected = res.data[0] ?? {}
                }
            }).catch(e => {
                console.log(e)
            }).finally(() => this.loading = false)
        },
        getDate(value) {
            if (!value) return ''
            return moment(value).format('DD-MM-YYYY HH:mm:ss')
        },
        handleSelectHistory(history) {
            this.historySelected = history
        },
    },
    mounted() {
        this.getHistory()
    }
}
</script>

<style scoped>
.layout-history {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 20px;
}
.layout-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.sidebar-left {
    border: 1px solid lightgray;
    max-height: 400px;
    overflow-y: auto;
}
.highlight-version {
    border: 1px solid green;
}
.not-highlight__version {
    border: 1px solid lightgray;
}
</style>
